const data = [{
  uuid: 'd2b45ff9-db51-4e9d-b382-a430eb4b0710',
  name: 'CB-Kennung test',
  code: null,
  type: 'profile',
  required: false,
  input_type: 'select',
  children: [{
    uuid: '39d9d489-a984-4088-8f90-b4c67f141106',
    name: 'CB-Kennung test',
    code: 'CB3GASL _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: '2e416f3a-9b62-4d93-8786-018d77bf58c5',
    name: 'CB-Kennung test',
    code: 'CB1J456 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: 'dac8bd6e-02d0-4c21-a2a0-e640fd21ef1a',
    name: 'CB-Kennung test',
    code: 'CB1E684 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: '145a99db-ec48-4260-b63a-f1e56653d3e5',
    name: 'CB-Kennung test',
    code: 'CB1Q083 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: 'a48a2866-16ca-4565-a50d-4515dbdf2958',
    name: 'CB-Kennung test',
    code: 'CB2DE74 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: 'dc9bccca-8685-4d90-a3e5-d143d4f55de7',
    name: 'CB-Kennung test',
    code: 'CB2DXAN _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: 'dc0adc37-2dc6-43e0-8878-c7116bad6314',
    name: 'CB-Kennung test',
    code: 'CB12062 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: '73b754d6-75c7-409e-b74e-2f079155f5a1',
    name: 'CB-Kennung test',
    code: 'CB11944 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: '8c5242cb-ab99-4998-abcc-3ff616d31bbd',
    name: 'CB-Kennung test',
    code: 'CB3GLON _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }, {
    uuid: '216646d7-5c4c-4bae-bd3e-90a61e3f3d71',
    name: 'CB-Kennung test',
    code: 'CB13047 _test',
    type: 'profile',
    required: false,
    input_type: 'select',
    children: null,
  }],
}, {
  uuid: '84d96b9c-3a25-42af-930a-367cba83b001',
  name: 'Employee ID',
  code: '',
  type: 'profile',
  required: true,
  input_type: 'text',
  children: null,
}];

export default data;
